import styled, { css } from 'styled-components';
import { HoverElementProps, HoverPopupProps, TOOLTIP_POSITION } from './types';

const contentPositionStyles = {
  bottom: css`
    top: calc(100% + 12px);
    left: 50%;
    transform: translate(-50%);
  `,
  right: css`
    top: 50%;
    left: calc(100% + 12px);
    transform: translateY(-50%);
  `,
  left: css`
    top: 50%;
    right: calc(100% + 12px);
    transform: translateY(-50%);
  `,
  top: css`
    bottom: calc(100% + 12px);
    left: 50%;
    transform: translate(-50%);
  `,
};

const generateTriangleStyles = (position: TOOLTIP_POSITION, color: string) => {
  switch (position) {
    case 'top':
      return css`
        &:after {
          border-bottom-width: 0;
          border-top-color: ${color};
          bottom: -8px;
          left: 50%;
          transform: translateX(-50%);
        }
      `;
    case 'bottom':
      return css`
        &:after {
          border-top-width: 0;
          border-bottom-color: ${color};
          top: -8px;
          left: 50%;
          transform: translateX(-50%);
        }
      `;
    case 'right':
      return css`
        &:after {
          border-left-width: 0;
          border-right-color: ${color};
          top: 50%;
          left: -8px;
          transform: translateY(-50%);
        }
      `;
    case 'left':
      return css`
        &:after {
          border-right-width: 0;
          border-left-color: ${color};
          top: 50%;
          right: -8px;
          transform: translateY(-50%);
        }
      `;
    default:
      return '';
  }
};

export const HoverPopup = styled.div<HoverPopupProps>`
  visibility: hidden;
  opacity: 0;
  position: absolute;
  ${(props) => contentPositionStyles[props.position]}
  height: auto;
  width: max-content;
  padding: 8px 12px;
  background: ${({ theme }) => theme.colors.white[100]};
  border: ${({ theme }) => `1px solid ${theme.colors.primary['non_alpha']}`};
  box-shadow: ${({ theme }) => `0px 8px 32px ${theme.colors.black[10]}`};
  border-radius: 5px;
  z-index: 99;
  cursor: initial;

  &:after {
    content: '';
    display: block;
    position: absolute;
    border-style: solid;
    border-width: 8px;
    border-color: transparent;
    z-index: 1;
  }

  ${({ position, style, theme }) =>
    generateTriangleStyles(
      position,
      style?.background || theme.colors.white[100]
    )}
`;

export const HoverElement = styled.div<HoverElementProps>`
  position: relative;
  ${({ hoverable }) =>
    hoverable
      ? css`
          &:hover ${HoverPopup} {
            visibility: visible;
            opacity: 1;
            transition-delay: 300ms;
          }
        `
      : null}
`;

export const ContainerWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
`;
